import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    auth,
    logInWithEmailAndPassword,
    signInWithGoogle
} from "../../Firebase";
import { useAuthState } from "react-firebase-hooks/auth";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();
    useEffect(() => {
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (user) navigate("/qtig");
    }, [user, loading]);
    return (
        <div className="login">
            <div className="form_container1">
                <input
                    type="text"
                    className="login__textBox"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-mail Address"
                />
                <input
                    type="password"
                    className="login__textBox"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                />
                <button
                    className="action_btn"
                    onClick={() => logInWithEmailAndPassword(email, password)}
                >
                    Login
                </button>
                <button className="action_btn_google" onClick={signInWithGoogle}>
                    Login with Google
                </button>
                <div className='login__text'>
                    <Link to="reset">Forgot Password</Link>
                    <p>Don't have an account? <Link to="register">Register</Link> now.</p>
                </div>
            </div>
        </div>
    );
}
export default Login;
